export default __webpack_public_path__ + "static/media/cupon-pensioner.356aa809.pdf";